import type { ApiToBridgePromptMessage } from '../../../../types/api-to-bridge-messages.js';
import type { SessionAttachmentRef } from '../../fetch-session-attachments.js';

export function parseBridgeAttachments(msg: ApiToBridgePromptMessage): SessionAttachmentRef[] {
  const raw = msg.attachments;
  if (!Array.isArray(raw)) return [];
  const out: SessionAttachmentRef[] = [];
  for (const x of raw) {
    if (x === null || typeof x !== 'object' || Array.isArray(x)) continue;
    const o = x as Record<string, unknown>;
    const id = typeof o.attachmentId === 'string' ? o.attachmentId.trim() : '';
    if (!id) continue;
    const mt = typeof o.mimeType === 'string' && o.mimeType.trim() ? o.mimeType.trim() : 'application/octet-stream';
    out.push({ attachmentId: id, mimeType: mt });
  }
  return out;
}
